/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LaundryGroupPriceListReference } from './LaundryGroupPriceListReference';
import {
    LaundryGroupPriceListReferenceFromJSON,
    LaundryGroupPriceListReferenceFromJSONTyped,
    LaundryGroupPriceListReferenceToJSON,
} from './LaundryGroupPriceListReference';

/**
 * 
 * @export
 * @interface LaundryGroupPriceListReferenceList
 */
export interface LaundryGroupPriceListReferenceList {
    /**
     * 
     * @type {Array<LaundryGroupPriceListReference>}
     * @memberof LaundryGroupPriceListReferenceList
     */
    result: Array<LaundryGroupPriceListReference>;
}

/**
 * Check if a given object implements the LaundryGroupPriceListReferenceList interface.
 */
export function instanceOfLaundryGroupPriceListReferenceList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function LaundryGroupPriceListReferenceListFromJSON(json: any): LaundryGroupPriceListReferenceList {
    return LaundryGroupPriceListReferenceListFromJSONTyped(json, false);
}

export function LaundryGroupPriceListReferenceListFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupPriceListReferenceList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(LaundryGroupPriceListReferenceFromJSON)),
    };
}

export function LaundryGroupPriceListReferenceListToJSON(value?: LaundryGroupPriceListReferenceList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(LaundryGroupPriceListReferenceToJSON)),
    };
}

